import { createContext, useContext, useState } from "react";

type ChatSelectionValue = {
    selecting: boolean;
    selectedIds: string[];
    isSelected: (id: string) => boolean;
    toggle: (id: string) => void;
    clearSelection: () => void;
};

const noopSelection: ChatSelectionValue = {
    selecting: false,
    selectedIds: [],
    isSelected: () => false,
    toggle: () => {},
    clearSelection: () => {},
};

const ChatSelectionContext = createContext<ChatSelectionValue>(noopSelection);

export function ChatSelectionProvider({ children }: { children: React.ReactNode }) {
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const selecting = selectedIds.length > 0;

    function toggle(id: string) {
        setSelectedIds((current) =>
            current.includes(id)
                ? current.filter((item) => item !== id)
                : [...current, id],
        );
    }

    function clearSelection() {
        setSelectedIds([]);
    }

    function isSelected(id: string) {
        return selectedIds.includes(id);
    }

    const value: ChatSelectionValue = {
        selecting,
        selectedIds,
        isSelected,
        toggle,
        clearSelection,
    };

    return (
        <ChatSelectionContext.Provider value={value}>
            {children}
        </ChatSelectionContext.Provider>
    );
}

export function useChatSelection(): ChatSelectionValue {
    return useContext(ChatSelectionContext);
}
